import { lazy, Suspense } from "react"

import { getPermissionValueAtPath } from "../../../../../components/PermissionGate/PermissionGate.tsx"
import { useAppSelector } from "../../../../../hooks/use-app-selector.ts"
import { useFpeTask } from "./fpe-task-store.ts"

const FpeWizard = lazy(() =>
  import("./FpeWizard.tsx").then((module) => ({ default: module.FpeWizard }))
)

const VIEW = "ai_center.sow_receivables.sow_receivables_view"

// Mounted once in the signed-in shell, so the wizard sits over whatever page the
// user is on and its minimized card follows them around the app. Nothing loads
// until a draft is opened.
export function FpeWizardHost() {
  const task = useFpeTask()
  const enabled = useAppSelector(
    (state) => state.auth?.userInfo?.feature_ai_center === true
  )
  const codes = useAppSelector((state) => state.auth?.permissions?.codes)
  if (!task || !enabled || !getPermissionValueAtPath(codes, VIEW)) return null
  return (
    <Suspense fallback={null}>
      <FpeWizard key={task.analysisId} task={task} />
    </Suspense>
  )
}
